/**
 * Whether an answer_data field counts as non-empty (string, number, or nested arrays of scalars).
 * Similar-paper AI may return correct_answer_text as an array.
 */
export const answerFieldNonEmpty = (value) => {
  if (value === null || value === undefined || value === "") return false;
  if (Array.isArray(value)) {
    return value.some((item) => answerFieldNonEmpty(item));
  }
  if (value !== null && typeof value === "object") {
    return Object.keys(value).length > 0;
  }
  return true;
};

/** MCQ-style: any option marked correct */
export const optionsHaveCorrectMark = (options) =>
  Array.isArray(options) && options.some((o) => o && o.is_correct);

/**
 * True if the question has enough answer-key data to show an Answer block (aligned with similar-paper JSON shapes).
 */
export const questionHasRenderableAnswer = (q) => {
  if (!q) return false;
  const ad = q.answer_data || {};
  const type = q.type;

  switch (type) {
    case "multiple-choice":
    case "multiple-select":
    case "true-false": {
      if (Array.isArray(ad.correct_options) && ad.correct_options.length > 0) return true;
      if (optionsHaveCorrectMark(q.options)) return true;
      return answerFieldNonEmpty(ad.correct_answer_text);
    }
    case "fill-in-the-blank":
    case "multi-fill": {
      if (Array.isArray(ad.correct_blanks) && ad.correct_blanks.length > 0) return true;
      return (
        answerFieldNonEmpty(ad.correct_answer_text) ||
        answerFieldNonEmpty(ad.model_answer)
      );
    }
    case "matching":
      if (Array.isArray(ad.pairs) && ad.pairs.length > 0) return true;
      return answerFieldNonEmpty(ad.correct_answer_text);
    case "ordering": {
      const ord = ad.correct_order ?? ad.correct_ordering_items;
      if (Array.isArray(ord) && ord.length > 0) return true;
      return answerFieldNonEmpty(ad.correct_answer_text);
    }
    case "essay":
      return answerFieldNonEmpty(ad.model_answer) || answerFieldNonEmpty(ad.correct_answer_text);
    case "short-answer":
      return answerFieldNonEmpty(ad.correct_answer_text) || answerFieldNonEmpty(ad.model_answer);
    case "grouped":
      return false;
    default:
      return (
        answerFieldNonEmpty(ad.correct_answer_text) ||
        answerFieldNonEmpty(ad.model_answer)
      );
  }
};
